var LanguageDetectorNames;
(function (LanguageDetectorNames) {
    LanguageDetectorNames["BodyAttribute"] = "BodyAttribute";
    LanguageDetectorNames["Custom"] = "Custom";
    LanguageDetectorNames["DocumentElement"] = "DocumentElement";
    LanguageDetectorNames["ForcedLanguage"] = "ForcedLanguage";
    LanguageDetectorNames["MetaTag"] = "MetaTag";
    LanguageDetectorNames["Navigator"] = "Navigator";
    LanguageDetectorNames["Preview"] = "Preview";
    LanguageDetectorNames["QueryString"] = "QueryString";
    LanguageDetectorNames["Url"] = "Url";
    LanguageDetectorNames["Window"] = "Window";
})(LanguageDetectorNames || (LanguageDetectorNames = {}));
export default LanguageDetectorNames;
//# sourceMappingURL=LanguageDetectorNames.js.map